import { AbstractControl, ValidationErrors } from "@angular/forms";

export function conditionalRequiredValidator(isRequired: boolean) {
    return (control: AbstractControl): ValidationErrors | null => {
        if (isRequired && !control.value) {
            return { required: true };
        }
        return null;
    };
}
